export const fmtNumber = (val) => {
    if (val === null || val === undefined || !Number.isFinite(val))
        return "-";
    // toLocaleString drops trailing .0 automatically (e.g. 4.0 -> "4", 6.1 -> "6.1")
    return val.toLocaleString("en-US", { maximumFractionDigits: 2 });
};
export const fmtCurrency = (val) => {
    if (val === null || val === undefined || !Number.isFinite(val))
        return "-";
    return `$${val.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
};
export const fmtPercent = (val) => {
    if (val === null || val === undefined || !Number.isFinite(val))
        return "-";
    // Show up to 1 decimal place; integers render without the trailing .0
    return `${val.toLocaleString("en-US", { maximumFractionDigits: 1 })}%`;
};
export const getRowName = (row) => {
    if (row.user_id) {
        const u = row.user_id;
        return `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.email || "-";
    }
    return row.nc || "-";
};
/* NC values that count as a Channel; every other NC is treated as a Network */
export const NC_CHANNEL_CATEGORIES = ["Affiliate", "Paid Media"];
export const ROW_KIND_META = {
    T: { label: "T", tooltip: "Team", index: 4 },
    C: { label: "C", tooltip: "Channel", index: 5 },
    N: { label: "N", tooltip: "Network", index: 2 },
};
/* Team = person row (user_id); Channel = NC in NC_CHANNEL_CATEGORIES; Network = any other NC */
export const getRowKind = (row) => {
    if (row.user_id)
        return "T";
    const nc = (row.nc || "").trim().toLowerCase();
    return NC_CHANNEL_CATEGORIES.some((c) => c.toLowerCase() === nc) ? "C" : "N";
};
const GOAL_DATE_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;
export const isValidGoalDate = (val) => {
    if (typeof val !== "string")
        return false;
    if (!GOAL_DATE_REGEX.test(val))
        return false;
    const year = Number(val.slice(0, 4));
    return year >= 2000 && year <= 2100;
};
